import Clarity from '@microsoft/clarity';

import { clarityId } from '@/constants/general';

const excludeDomains = ["local.downfor.life"];

export const initClarity = async () => {
  try {
    const { hostname } = window?.location || {};

    if (!window.clarity && !excludeDomains.includes(hostname)) {
      Clarity.init(clarityId);

      const awaitTimes = 10
      let iterationCount = 0;

      const verifyClarity = setInterval(() => {
        if (window.clarity) {
          window.clarityReady = true;
          clearInterval(verifyClarity);
          Clarity.consent(true);
        } else {
          if (iterationCount === awaitTimes) {
            clearInterval(verifyClarity);
            window.clarityReady = false;
          }
        }
        iterationCount += 1;
      }, 500);
    }
    return true
  } catch (e) {
    console.log(`Error on Clarity initialization: ${e.toString()}`)
  }
  return false
}

export default initClarity
